<template>
    <div class="root-box">
        <div
            class="main-box">
            <div class="content-box">
                <div class="video-area">
                    <Video ref="video"/>
                    <ControllerBar/>
                </div>
                <CommodityPanel
                    ref="panel"/>
            </div>
        </div>
        <RestPage v-if="rest"/>
        <FetchingPage v-else-if="fetchingNewOrder"/>
        <TimeoutPage v-else-if="orderTimeout"/>
        <audio
            ref="audio"
            style="display: none;"
            src="https://goldbox-static.oss-cn-shanghai.aliyuncs.com/marker/notify.mp3">
        </audio>
    </div>
</template>

<script>
 import Video from "./Video.vue"
 import ControllerBar from "./ControllerBar.vue"
 import CommodityPanel from "./CommodityPanel.vue"
 import FetchingPage from "./FetchingPage.vue"
 import RestPage from "./RestPage.vue"
 import TimeoutPage from "./TimeoutPage.vue"
 import EventBus from "../event/event-bus.js"

 import { mapGetters } from 'vuex'
 import { fetchOrder } from "../util/order.js"

 export default {
     name: 'Home',
     data() {
         return {
             rest: false,
             orderTimeout: false,
             fetchingNewOrderCallback: -1,
             tickerCallback: -1,
             refreshTokenCallback: -1
         }
     },
     props: {
     },
     components: {
         ControllerBar,
         Video,
         CommodityPanel,
         RestPage,
         FetchingPage,
         TimeoutPage
     },
     computed: {
         ...mapGetters([
             "fetchingNewOrder"
         ]),
     },
     created() {
         console.log("Create Home")
     },
     mounted() {
         console.log("Mount Home")

         this.fetchNewOrder()

         EventBus.$on("fetchNextOrder", this.fetchNextOrder)
         EventBus.$on("restBack", this.restBack)
         EventBus.$on("timeoutBack", this.timeoutBack)
         EventBus.$on("restFromFetching", this.restFromFetching)

         this.monitorToken()
     },
     beforeDestroy() {
         EventBus.$off("fetchNextOrder")
         EventBus.$off("restBack")
         EventBus.$off("timeoutBack")
         EventBus.$off("restFromFetching")
     },
     watch: {
         '$store.state.orderIdentificationTime': {
             handler: function(newer, ) {
                 if (newer > this.$store.getters.orderExpiredAfter) {
                     this.timeout()
                 }
             },
             deep: true
         },
     },
     beforeRouteLeave (to, from, next) {
         this.clearRefreshTokenCallback()
         this.clearTickerCallback()
         this.clearFetchingNewOrderCallback()

         next(vm => vm.previousRoute = from)
     },
     methods: {
         fetchNewOrder() {
             var that = this

             fetchOrder(
                 function(orderId, consumerOrderId, stats, consumerCommodities, cupboardCommodities, videoUrl, expiredAfter, priority) {
                     console.log("fetchNewOrder success")

                     that.$store.commit("updateOrderId", orderId)
                     that.$store.commit("updateConsumerOrderId", consumerOrderId)
                     that.$store.commit("updatePriority", priority)
                     that.$store.commit("updateIdentifyingPersonalStats", stats)
                     that.$store.commit("changeOrderVideoUrl", videoUrl)
                     that.$store.commit("changeOrderConsumerCommodities", consumerCommodities)
                     that.$store.commit("changeOrderCupboardCommodities", cupboardCommodities)
                     that.$store.commit("updateHelpStatus", true)
                     that.$store.commit("updateInfoStatus", true)
                     that.$store.commit("updateOrderExpiredAfter", expiredAfter)

                     /* 下一单之前，先同步视频的倍率, 需要稍微延迟一下才能更换下一个视频的播放速度 */
                     setTimeout(function () {
                         if (that.$refs.video) {
                             that.$refs.video.syncRate()
                         }
                     }, 200)

                     EventBus.$emit("downloadProgress", 0)

                     var needPlayAudio = that.$store.getters.fetchingNewOrder

                     that.$store.commit("updateFetchingNewOrder", false)
                     that.clearFetchingNewOrderCallback()
                     that.clearTickerCallback()
                     that.tickerCallback = setInterval(function() {
                         that.$store.commit("tickOrderIdentificationTime")
                     }, 1000)

                     /* NOTE: 播放声音的代码放到最后，避免出错以后导致订单状态不对 */
                     if (needPlayAudio) {
                         try {
                             let playPromise =that.$refs.audio.play()
                             if (playPromise !== undefined) {
                               playPromise.then(() => {
                                 that.$refs.audio.play()
                               }).catch((e)=> {
                                 console.log("play audio catch:", e);
                               })
                             }
                         } catch (e) {
                             console.log("Play audio error: ", e)
                         }
                     }
                 },
                 function() {
                     console.log("fetchNewOrder failed")

                     that.$store.commit("updateFetchingNewOrder", true)

                     if (that.$refs.panel) {
                         that.$refs.panel.hideCommodityThumbnail()
                     }

                     that.fetchingNewOrderCallback = setTimeout(function () {
                         /* 超时检测只有当 fetchingNewOrder 为 true 时才去获取新的订单  */
                         if (that.$store.getters.fetchingNewOrder) {
                             that.fetchNewOrder()
                         }
                     }, 3000)
                 },
                 function() {
                     console.log("fetchNewOrder error")

                     that.$router.replace("/")
                 }
             )
         },

         fetchNextOrder() {
             this.cleanupState()

             if (this.$store.getters.restMoment) {
                 this.rest = true
                 if (this.$refs.panel) {
                     this.$refs.panel.hideCommodityThumbnail()
                 }
             } else {
                 this.fetchNewOrder()
             }
         },

         restBack() {
             this.rest = false
             this.$store.commit("updateRestMoment", false)
             this.fetchNewOrder()
         },

         timeout() {
             this.cleanupState()
             this.orderTimeout = true
             if (this.$refs.panel) {
                 this.$refs.panel.hideCommodityThumbnail()
             }
         },

         timeoutBack() {
             this.orderTimeout = false
             this.fetchNewOrder()
         },

         restFromFetching() {
             this.clearFetchingNewOrderCallback()
             this.rest = true
             if (this.$refs.panel) {
                 this.$refs.panel.hideCommodityThumbnail()
             }
         },

         cleanupState() {
             this.$store.commit("updateOrderId", 0)
             this.$store.commit("updateConsumerOrderId", 0)
             this.$store.commit("updatePriority", 0)
             this.$store.commit("updateIdentifyingPersonalStats", {})
             this.$store.commit("updateOrderNumber", 0)
             this.$store.commit("playerPause")
             this.$store.commit("changeOrderVideoUrl", "")
             this.$store.commit("changeOrderConsumerCommodities", [])
             this.$store.commit("changeOrderCupboardCommodities", [])
             this.$store.commit("changeShoppingCommodities", {})
             this.$store.commit("updateExceptionOption", -1)
             this.$store.commit("updateHelpStatus", false)
             this.$store.commit("updateInfoStatus", false)
             this.$store.commit("updateVideoCurrentTime", "")
             this.$store.commit("updateVideoDuration", "")
             this.$store.commit("resetOrderIdentificationTime")
             this.$store.commit("updateOrderExpiredAfter", 0)
             this.clearTickerCallback()
         },

         clearTickerCallback() {
             if (this.tickerCallback != -1) {
                 clearInterval(this.tickerCallback)
                 this.tickerCallback = -1
             }
         },

         clearRefreshTokenCallback() {
             if (this.refreshTokenCallback != -1) {
                 clearInterval(this.refreshTokenCallback)
                 this.refreshTokenCallback = -1
             }
         },

         clearFetchingNewOrderCallback() {
             if (this.fetchingNewOrderCallback != -1) {
                 clearTimeout(this.fetchingNewOrderCallback)
                 this.fetchingNewOrderCallback = -1
             }
         },

         monitorToken() {
             var checkInterval = 60 * 60 // one hour
             var that = this

             this.refreshTokenCallback = setInterval(function() {
                 var loginDate = new Date(sessionStorage.getItem("loginDate"))
                 var now = new Date()
                 var diffSeconds = (now.getTime() - loginDate.getTime()) / 1000
                 var refreshTokenInterval = 60 * 60 * 24 * 3 // three days

                 if (diffSeconds > refreshTokenInterval) {
                     var url = process.env.VUE_APP_API_SERVER + '/auth/refresh-token'
                     var data = {};

                     fetch(url, {
                         method: 'POST', // or 'PUT'
                         body: JSON.stringify(data), // data can be `string` or {object}!
                         headers: new Headers({
                             'Content-Type': 'application/json',
                             'Access-Token': sessionStorage.getItem('accessToken')
                         })
                     }).then(res => res.json())
                       .catch(error => {
                           console.log("monitorToken: ", error)

                           sessionStorage.setItem("refreshToken", true)

                           that.$router.replace("/")
                       })
                       .then(response => {
                           sessionStorage.setItem("accessToken", response.accessToken)
                           sessionStorage.setItem("loginDate", now)
                           sessionStorage.setItem("role", response.role)
                           console.log("Refresh token success")
                       });
                 }
             }, checkInterval)
         },
     }
 }
</script>

<style scoped>
 .root-box {
     width: 100%;
     height: 100%;

     position: relactive;
 }

 .main-box {
     display: flex;
     flex-direction: column;
     width: 100%;
     height: 100%;
 }

 .content-box {
     display: flex;
     flex-direction: row;
     width: 100%;
     height: 100%;
 }

 .video-area {
     flex: 1;
     display: flex;
     flex-direction: column;
 }
</style>
